import { render, staticRenderFns } from "./GalaxyMarsTwo.vue?vue&type=template&id=6e79e410&scoped=true"
import script from "./GalaxyMarsTwo.vue?vue&type=script&lang=js"
export * from "./GalaxyMarsTwo.vue?vue&type=script&lang=js"
import style0 from "./GalaxyMarsTwo.vue?vue&type=style&index=0&id=6e79e410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e79e410",
  null
  
)

export default component.exports